module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAWCAYAAAAmaHdCAAABV0lEQVQ4T73Uv0tWURzH8dcjTiUE4uIQoQ5Bi4Oh4JouuoQO0m7gkoM0SDoYQkvp4q/BWQgHBUEHhQaDwoZQygZREfUvcHAxMo6cBy6Xe58fCn7He76f9/nc8znnW5BdT/EO3ajHCZbxCRdpSSGD0RsFD+LaNYp9B+jCWVKXhjzGH9RhCWM4Rwfm0Yrv6CwF+Yi3WEVfymX4rd9oxAt8Ka6nneygPe4UdkzXJMYxgfd5kEO04AlOMyBDWMAMhvMgR2iuADKLN0lIA0ajgxDpQ2ziMsNJUzzcY/zEV8yFM9mKseVcmbKfRwLkCrVlW/Mb1gIkXKa71Ma9QL5hDz0xsSzHJZ18xquoeoRfCM8iXSUh/VhJKBYxWC3kQ3yAQVeDH2irFhKin8YuBvAyJ8L7SaeS+3Pj5F9iclUiSvesB8g+nt1GHTVTAfI8jr4wR7Jmbh7/L7bx+j8d4kbqw4ATiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/login-pwd.png
// module id = C+vZ
// module chunks = 1